// src/pages/controleBar/comandas/CadComanda.js
import React, { useEffect, useState } from 'react';
import './CadComanda.css';
import Input from '../../../components/input/Input';
import { useComanda } from '../../../contexts/controleBar/comandas/ComandaContext';
import { useCliente } from '../../../contexts/pessoas/ClienteContext';
import { useAlert } from '../../../contexts/geral/AlertContext';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useMesa } from '../../../contexts/controleBar/mesas/MesaContext';
import { useNavigate } from 'react-router-dom';
import ModalPortal from '../../../components/modalForm/ModalPortal';

const CadComanda = ({ open, onClose, comandaEdicao = null }) => {
  const [comanda, setComanda] = useState({ codigo: "", clienteId: 1, nomeCliente: "" });
  const [isSaving, setIsSaving] = useState(false); // ✅ novo estado

  const { clientes, showClienteSearch, showClienteCad } = useCliente();
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();
  const navigate = useNavigate();

  const { addComanda, updateComanda } = useComanda();
  const { mesaSel } = useMesa(); 
  const isEditing = Boolean(comandaEdicao?.id);

  const handleBuscarCliente = async () => {
    const clienteSel = await showClienteSearch();
    handleClienteExit(clienteSel.id);
  };

  const handleClienteExit = (clienteId) => {
    if (!clienteId) return;
    const clienteSelecionado = clientes.find(f => f.id.toString() === clienteId.toString());
    if (clienteSelecionado) {
      setComanda({ ...comanda, clienteId: clienteSelecionado.id, nomeCliente: clienteSelecionado.pessoa?.nome });
    } else {
      showAlert('Cliente não encontrado!', 'danger');
      setComanda({ ...comanda, clienteId: '', clienteNome: '' });
    }
  };

  useEffect(() => {
    if (open) {
      if (comandaEdicao?.id) {
        setComanda({ ...comandaEdicao });
        setIsSaving(false);
        return;
      }

      const clienteSelecionado = clientes.find(f => f.id === 1);
      setComanda({ codigo: "", clienteId: 1, nomeCliente: clienteSelecionado?.pessoa?.nome || "" });
      setIsSaving(false); // ✅ garante reset ao abrir
    }
  }, [open, comandaEdicao]);

  if (!open) return null;

  const handleSave = async () => {
    if (isSaving) return; // ✅ impede clique duplo
    if (comanda.clienteId === "") {
      showMessage('Informe um cliente!', 'warning');
      return;
    }

    setIsSaving(true); // ✅ bloqueia botão

    try {
      if (isEditing) {
        const comandaResult = await updateComanda(comanda);
        if (comandaResult) {
          onClose();
        }
        return;
      }

      const payload = mesaSel.id
        ? { ...comanda, mesaId: mesaSel.id }
        : { ...comanda, mesa: mesaSel };

      const comandaResult = await addComanda(payload);

      sessionStorage.removeItem("mesaPayload");

      if (!mesaSel.id) {
        navigate(`/mesaControlePage/${comandaResult.mesa.id}`);
      }

      onClose();
    } catch (err) {
      console.error("Erro ao salvar comanda:", err);
      showAlert("Erro ao salvar comanda", "danger");
    } finally {
      setIsSaving(false); // ✅ reativa botão mesmo se der erro
    }
  };

  return (
    <ModalPortal show={open}>
    <div className="modal-overlay">
      <div className="modal-box" style={{ width: '520px' }}>
        <h2>{isEditing ? "Editar Comanda" : "Nova Comanda"}</h2>
        <div className="input-group">
          <Input
            label="Código"
            value={comanda.codigo || ''}
            onChange={(e) => setComanda({ ...comanda, codigo: e.target.value.slice(0, 20) })}
            size={150}
            maxLength={20}
            autoFocus
          />
        </div>
        <div className="input-group">
          <Input
            label="Cliente"
            value={comanda.clienteId || ''}
            onChange={(e) => setComanda({ ...comanda, clienteId: e.target.value })}
            btnBuscar={handleBuscarCliente}
            btnAdd={showClienteCad}
            onBlur={(e) => handleClienteExit(e.target.value)}
          />
          <Input
            label="Nome"
            value={comanda?.nomeCliente}
            onChange={(e) => setComanda({ ...comanda, nomeCliente: e.target.value })}
            size={250}
          />
        </div>
        <div className="modal-actions">
          <button
            tabIndex={-1}
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isSaving} // ✅ desabilita também o cancelar durante save
          >
            Cancelar
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
            disabled={isSaving} // ✅ botão salvar desabilitado durante a operação
          >
            {isSaving ? "Salvando..." : "Salvar"} {/* ✅ texto dinâmico */}
          </button>
        </div>
      </div>
    </div>
    </ModalPortal>
  );
};

export default CadComanda;
